import { StockProductionCenter } from 'types/models/StockReceipt';
import axiosInstance from './axios';
import PaginationData from 'types/models/PaginationData';
import joinURLParams from 'utils/joinUrlParams';

const PRODUCTION_CENTERS_URL = 'stock/production-centers';
export const getStockProductionCenters = async (venueId?: string): Promise<PaginationData<StockProductionCenter>> => {
  try {
    const { data: paginationData } = await axiosInstance({
      method: 'get',
      url: venueId ? joinURLParams({ venueId }, PRODUCTION_CENTERS_URL) : PRODUCTION_CENTERS_URL,
    });
    return {
      currentPage: paginationData.current_page,
      data: parseStockProductionCenters(paginationData.data ?? []),
      perPage: paginationData.per_page,
      total: paginationData.total,
    };
  } catch (error) {
    throw error;
  }
};
export const getVenueProductionCenters = async (venueId: string): Promise<StockProductionCenter[]> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `${PRODUCTION_CENTERS_URL}?venueId=${venueId}&isActive=true&simple=true`,
    });
    return parseStockProductionCenters(data);
  } catch (error) {
    throw error;
  }
};

export const getStockProductionCenter = async (id: string): Promise<StockProductionCenter> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `${PRODUCTION_CENTERS_URL}/${id}`,
    });
    return parseProductionCenter(data);
  } catch (error) {
    throw error;
  }
};

export const storeStockProductionCenter = async (
  payload: Omit<StockProductionCenter, 'id'>,
): Promise<StockProductionCenter> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: PRODUCTION_CENTERS_URL,
      data: payload,
    });
    return parseProductionCenter(data);
  } catch (error) {
    throw error;
  }
};

export const updateStockProductionCenter = async (
  id: string,
  payload: Omit<StockProductionCenter, 'id'>,
): Promise<StockProductionCenter> => {
  try {
    const { data } = await axiosInstance({
      method: 'put',
      url: `${PRODUCTION_CENTERS_URL}/${id}`,
      data: payload,
    });
    return parseProductionCenter(data);
  } catch (error) {
    throw error;
  }
};

export const deleteStockProductionCenter = async (id: string): Promise<StockProductionCenter> => {
  try {
    const { data } = await axiosInstance({
      method: 'delete',
      url: `${PRODUCTION_CENTERS_URL}/${id}`,
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};

const parseStockProductionCenters = (data: any[]): StockProductionCenter[] => {
  return data.map(parseProductionCenter);
};

export const parseProductionCenter = (item: any): StockProductionCenter => {
  return {
    id: item.id,
    name: item.name,
    type: item.type,
    venueId: item.venue_id,
    isActive: item.is_active,
  };
};
